import React, { useMemo } from "react";
import cx from "classnames";
import { useSelector } from "hooks";
import type { PickemsContestWithMarkets } from "@/hooks/firestore/v2/pickems/usePickemsContest";
import { useEntry } from "hooks/firestore/betting/useEntries";
import type { PickemsEntry } from "hooks/firestore/pickems/types";
import { selectPointsPotential } from "./pickslipSlice";
import * as styles from "./PickSlip.module.scss";
import PickSlipFooterAction from "./PickSlipFooterAction";

type PickSlipFooterProps = {
  contest: PickemsContestWithMarkets;
  existingPickCount: number;
  canMakePick: boolean;
  pickCount: number;
  marketCount: number;
};

const PickSlipFooter = ({
  contest,
  existingPickCount,
  canMakePick,
  pickCount,
  marketCount,
}: PickSlipFooterProps) => {
  const [entry] = useEntry<PickemsEntry>(contest.id);
  const pointsPotential = useSelector((state) =>
    selectPointsPotential(state, contest, entry),
  );
  const justAccepted = useSelector((state) => !!state.pickslip.justAccepted);
  // intentionally exclude existingPickCount to avoid flicker
  const leftLabel = useMemo(() => {
    return justAccepted ? "Picks" : existingPickCount > 0 ? "Changes" : "Picks";
  }, [justAccepted]);

  return (
    <div className={styles.footer}>
      <div className={styles.info}>
        <div className={styles.panel}>
          <div className={styles.label}>{leftLabel}</div>
          <div className={cx(styles.value, styles.pickCount)}>
            <div
              style={{
                width: `calc(0.7rem * ${pickCount.toString().length})`, // to avoid the count font shifts
              }}
            >
              {pickCount}
            </div>
            /{marketCount}
          </div>
        </div>
        <div className={cx(styles.panel, styles.right)}>
          <div className={styles.label}>Points</div>
          <div className={styles.value}>{pointsPotential} PTS</div>
        </div>
      </div>
      <div className={styles.buttons}>
        <PickSlipFooterAction
          contest={contest}
          entry={entry}
          existingPickCount={existingPickCount}
          canMakePick={canMakePick}
        />
      </div>
    </div>
  );
};

export default PickSlipFooter;
